import Tooltip from 'bootstrap/js/src/tooltip';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Tooltip = Tooltip;
